import "./FormSection.css";

export default function FormSection({

    title,

    description,

    icon,

    children

}){

    return(

        <section className="form-section">

            {

                (title || description) &&

                <div className="form-section-header">

                    <div className="form-section-title">

                        {

                            icon &&

                            <span className="form-section-icon">

                                {icon}

                            </span>

                        }

                        <div>

                            {

                                title &&

                                <h3>

                                    {title}

                                </h3>

                            }

                            {

                                description &&

                                <p>

                                    {description}

                                </p>

                            }

                        </div>

                    </div>

                </div>

            }

            <div className="form-section-body">

                {children}

            </div>

        </section>

    );

}